import styled from "@emotion/styled";
export const PermissionsEditorRoot = styled.div`
  flex-grow: 1;
  position: relative;
  overflow: auto;
  padding: 1rem 0 0 0;
`;
